import { render, staticRenderFns } from "./OrderPropertyReportPopUp.vue?vue&type=template&id=37f1a76a&scoped=true&"
import script from "./OrderPropertyReportPopUp.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyReportPopUp.vue?vue&type=script&lang=js&"
import style0 from "./OrderPropertyReportPopUp.vue?vue&type=style&index=0&id=37f1a76a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1a76a",
  null
  
)

export default component.exports